import {
    REMARK_STATUS,
    REMARK_STATUS_SUCCESS,
    REMARK_STATUS_ERROR,
    REMARK_STATUS_EMPTY,
} from "../../actions";




const initialState = {
  data: null,
  message: null,
  loading: false,
  success: false,
  error: false,
};

const RemarkStatusDetails = (state = initialState, action) => {
  switch (action.type) {
    case REMARK_STATUS:
      state = {
        ...state,
        // data: null,
        loading: true,
        success: false,
        error: false,
        message: null,
      };
      break;

    case REMARK_STATUS_SUCCESS:
      state = {
        ...state,
        data: action.payload,
        loading: false,
        success: true,
        error: false,
        message: null,
      };
      break;

    case REMARK_STATUS_ERROR:
      state = {
        ...state,
        data: null,
        loading: false,
        success: false,
        error: true,
        message: action.payload,
      };
      break;

    case REMARK_STATUS_EMPTY:
      state = {
        ...initialState,
      };
      break;

    default:
      state = { ...state };
      break;
  }
  return state;
};

export default RemarkStatusDetails;
